import { render } from "./Strategic.vue?vue&type=template&id=30f716de&scoped=true&ts=true"
import script from "./Strategic.ts?vue&type=script&lang=ts"
export * from "./Strategic.ts?vue&type=script&lang=ts"

import "./Strategic.scss?vue&type=style&index=0&id=30f716de&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f716de"]])

export default __exports__